import React from "react";
import LoginLayout from "../../layouts/login.layout";
import { loginDefaultBanner } from "../../utils/constant/login.constant";
import { Navigate, useSearchParams } from "react-router-dom";
import SetNewPassword from "../../components/forgotPassword/SetNewPassword";

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  let encryptedToken = searchParams.get("token");

  if (encryptedToken) {
    encryptedToken = decodeURIComponent(encryptedToken.replace(/ /g, "+"));
  }

  if (!encryptedToken) {
    // redirect to home page
    return <Navigate to="/" replace />;
  }

  return (
    <LoginLayout sideBanner={loginDefaultBanner}>
      <div className="flex flex-col items-center w-full max-w-[700px]">{encryptedToken && <SetNewPassword token={encryptedToken} />}</div>
    </LoginLayout>
  );
};

export default ResetPasswordPage;
